import { useEffect } from "react";

function HousingDining() {
  useEffect(() => {
    document.title = "Housing & Dining";
  });

  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Housing &amp; Dining</h1>
          </div>
        <div class="sub-hrule"></div>
        </div>
        <div class="people-section">
          <div id="dfnav" class="from-navbar-ref"></div>
          <div id="df" class="page-nav-ref"></div>
          <div class="sub-head">
            <h3 class="h3">Student Maintenance Representative</h3>
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Student Maintenance Representatives (SMRs) act as a liaison between 
              Wiess and Housing & Dining relative to the routine physical 
              maintenance of the college. SMRs assist with issues concerning 
              Housing particularly on weekends, after-hours, and holidays.
            </p>
          </div>
          <div class="resa-grid">
            <div class="person-card">
              <div class="name">
                <h4 class="h4">Sammy Sissman</h4>
              </div>
              <div>
                <a class="position" href="mailto: ss353@rice.edu">
                  <u>ss353@rice.edu</u>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="people-section">
          <div id="dfnav" class="from-navbar-ref"></div>
          <div id="df" class="page-nav-ref"></div>
          <div class="sub-head">
            <h3 class="h3">Food Ambassadors</h3>
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Food Ambassadors work with Rice Dining to help shape campus dining 
              experiences, particularly at South Servery. They are a liaison 
              between Wiessmen and H&D staff to share feedback, communicate menu 
              suggestions, and advocate for dietary needs.
            </p>
          </div>
          <div class="resa-grid">
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/cab-faces/Isabelle Shen.jpg"
                  height="200"
                  alt="Isabelle Shen"
                />
              </div>
              <div class="name">
                <h4 class="h4">Isabelle Shen</h4>
              </div>
              <div>
                <a class="position" href="mailto: is51@rice.edu">
                  <u>is51@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/misc/Nathan Chen.jpg"
                  height="200"
                  alt="Nathan Chen"
                />
              </div>
              <div class="name">
                <h4 class="h4">Nathan Chen</h4>
              </div>
              <div>
                <a class="position" href="mailto: nc76@rice.edu">
                  <u>nc76@rice.edu</u>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Forms</h1>
          </div>
            <div class="sub-hrule" style={{ marginBottom: "30px" }}></div>
            <a
              href="https://rice.tririga.com"
              className="popup-button blm-button"
              style={{ marginBottom: "20px" }}
            >
              Work Order Form
            </a>
            <a
              href="https://forms.gle/qStBGKj4G35sZKwx7"
              className="popup-button blm-button"
            >
              South Servery Feedback Form
            </a>
        </div>
      </div>
    </div>
  );
}

export default HousingDining;
